<template>
  <div id="frontend-config" class="row">
    <form id="configure-frontend-form" class="small-12 medium-8 columns" @submit.prevent="submitForm">
      <label>
        {{ 'Date format'|t }}
        <input type="text" v-model="date_format" required="required" />
        <p class="help-text" v-html="formattingHint"></p>
      </label>

      <label>
        {{ 'Date-time format'|t }}
        <input type="text" v-model="time_format" required="required" />
        <p class="help-text" v-html="formattingHint"></p>
      </label>

      <label>
        {{ 'Welcome text'|t }}
        <textarea v-model="welcome" rows="5"></textarea>
      </label>

      <fieldset>
        <legend>{{ 'Translations'|t }}</legend>
        <table v-if="languages.length > 0">
          <thead>
            <tr>
              <th>{{ 'Language'|t }}</th>
              <th>{{ 'Alias'|t }}</th>
              <th>{{ 'Actions'|t }}</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="lc in languages" :key="lc">
              <td>{{ lc }}</td>
              <td>
                <select :data-lang="lc" @change="mapLang">
                  <option v-for="lang in langList" :key="lang" :value="lang" v-if="lc !== lang" :selected="isMapped(lc, lang)">{{ lang }}</option>
                </select>
              </td>
              <td>
                <nav class="menu inline">
                  <router-link :to="{name: 'frontend.update_language', params: {langcode: lc}}" tag="li">
                    <a><i class="icon icon-pencil"></i> <span>{{ 'Edit'|t }}</span></a>
                  </router-link>
                  <li>
                    <a @click.stop="deleteLanguage(lc)"><i class="icon icon-bin"></i> <span>{{ 'Delete'|t }}</span></a>
                  </li>
                </nav>
              </td>
            </tr>
          </tbody>
        </table>

        <p class="help-text callout" v-if="languages.length === 0">{{ 'No languages defined.'|t }}</p>
      </fieldset>

      <fieldset>
        <legend>{{ 'Logo'|t }}</legend>

        <div class="text-center callout" id="fe-logo-wrapper">
          <img :src="logo" alt="" v-if="logo.length > 0">
          <a id="remove-logo" class="alert button" v-if="logo.length > 0" @click="removeLogo"><i class="icon icon-bin"></i></a>
          <input v-if="logo.length === 0" @change="loadLogo" type="file" name="logo"
            accept=".jpg,.jpeg,.png,.webp,.gif,image/png,image/gif,image/jpeg,image/webp">
        </div>

      </fieldset>

      <input type="submit" name="submit" :value="'Submit'|t" class="medium expanded success button" />
    </form>
  </div>
</template>

<script>
  import api from '@/api';

  export default {
    name: 'ConfigurationForm',
    created() {
      let self = this;
      api.getFrontendConfig(
        {},
        data => {
          self.date_format = data.format_date;
          self.time_format = data.format_time;
          self.welcome = data.welcome;
          self.languages = data.languages;
          self.language_map = data.language_map;
          self.logo = data.logo_base64 || "";
        }
      );
    },
    data() {
      return {
        date_format: "",
        time_format: "",
        welcome: "",
        languages: [],
        language_map: {},
        logo: "",
      }
    },
    computed: {
      formattingHint: function() {
        return this.$root.$options.filters.t(
          'See formatting options in <a href="%s" target="_blank">here</a>.',
          'https://www.npmjs.com/package/fecha#formatting-tokens'
        )
      },
      langList: function() {
        return [''].concat(this.languages);
      },
    },
    methods: {
      submitForm() {
        let request = {
          format_time: this.time_format,
          format_date: this.date_format,
          welcome: this.welcome,
          language_map: this.language_map,
          logo_base64: this.logo,
        };

        api.configureFrontend(
          request,
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Settings have been saved.",
            }, {root: true});
          }
        );
      },
      deleteLanguage(ln) {
        api.deleteFrontendTranslation(
          {lang: ln},
          data => {
            this.$store.commit('messages/addMessage', {
              type: "status",
              message: "Settings have been saved.",
            }, {root: true});

            for (let i in this.languages) {
              if (this.languages[i] === ln) {
                this.languages.splice(i, 1);
                return;
              }
            }
          }
        );
      },
      mapLang(ev) {
        if (ev.target.value === "") {
          delete this.language_map[ev.target.dataset.lang];
        } else {
          this.language_map[ev.target.dataset.lang] = ev.target.value;
        }
      },
      isMapped(src, alias) {
        return src in this.language_map && this.language_map[src] === alias;
      },
      loadLogo(ev) {
        let self = this;
          if (ev.target.files && ev.target.files[0]) {
            const FR= new FileReader();

            FR.addEventListener("load", function(e) {
              if (e.total > 512000) {
                ev.target.value = "";
                this.$store.commit('messages/addMessage', {
                  type: "error",
                  message: "Image is larger than %s.",
                  args: ["0.5 MB"]
                }, {root: true});
              } else {
                self.logo = e.target.result;
              }
            });

            FR.readAsDataURL(ev.target.files[0]);
          }
      },
      removeLogo() {
        this.logo = ""
      }
    },
  }
</script>



// WEBPACK FOOTER //
// src/pages/frontend/ConfigurationForm.vue